import React, { useState } from "react";
import { Image } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import "./index.css";
import { Form, Input, Select, Button, message } from "antd";
import moment from "moment";
import { Upload } from "antd";
import dummy_user from "../../../../assets/images/dummy_user.png";
import edit_profile_icon from "../../../../assets/images/edit_profile_icon.png";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getOrganisationData } from "../../api/Organisation";
import { updateProfile } from "../../api/Organisation/update";
import { uploadFile } from "../../api/Upload/Image";
import { createProfile } from "../../api/Organisation/createUser";
import Table from "../../../common/components/Table";
import { getAdminDataList } from "../../api/Admin/AdminListSlice";
import useIsMobile from "../../components/shared/Mobile-Responsive";
export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const [form] = Form.useForm();
  const [formCreate] = Form.useForm();
  const [createFile, setCreateFile] = useState(null);
  const [updateFile, setUpdateFile] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState("Update Profile");
  const [image, setImage] = useState(null);
  const [updateImgUrl, setUpdateImgUrl] = useState(null);
  const [fileList, setFileList] = useState(null);
  const [userImage, setUserImage] = useState(dummy_user);
  const [createImage, setCreateImage] = useState(dummy_user);
  const [createUserImgUrl, setCreateUserImgUrl] = useState(null);
  const [list, setList] = useState([]);
  const [col, setCol] = useState([
    {
      title: "Name",
      key: "name",
      render: (_, record) => (
        <span className="table-item">
          {_.title + ". " + _.firstName + " " + _.lastName}
        </span>
      ),
    },
    {
      title: "Email ID",
      key: "email",
      render: (_, record) => <span className="table-item">{_.email}</span>,
    },

    {
      title: "Location",
      key: "location",
      render: (_, record) => (
        <>
          <span className="table-item-status">{_.location}</span>
        </>
      ),
    },
    {
      title: "Role",
      key: "role",
      render: (_, record) => (
        <>
          <span className="table-item-status">
            {_.role === "ENTERPRISE_ADMIN" ? "Event Admin" : "Admin"}
          </span>
        </>
      ),
    },
  ]);

  const onFinish = async (values) => {
    try {
      let userData;
      if (updateImgUrl === null) {
        userData = JSON.stringify({
          firstName: values.firstname,
          lastName: values.lastname,
          email: values.email,
          location: values.location,
          mobile_number: values.phone,
        });
      } else {
        userData = JSON.stringify({
          firstName: values.firstname,
          lastName: values.lastname,
          email: values.email,
          location: values.location,
          imageUrl: updateImgUrl,
          mobile_number: values.phone,
        });
      }
      let uid = values.userId;
      let res = await dispatch(updateProfile({ userData, uid }));
      if (res?.payload?.status === "success") {
        getProfile();
        message.success("Profile Updated");
      } else {
        message.success("Something went wrong");
      }
    } catch (error) {
    }
  };

  const onCreate = (values) => {
    let birth = moment(values.dob).format("YYYY-MM-DD");
    let userData;
    if (createUserImgUrl === null) {
      userData = JSON.stringify({
        title: values.title,
        firstName: values.create_firstname,
        lastName: values.create_lastname,
        role: values.role,
        email: values.create_email,

        location: values.create_location,
        mobile_number: values.create_phone,
      });
    } else {
      userData = JSON.stringify({
        title: values.title,
        firstName: values.create_firstname,
        lastName: values.create_lastname,
        role: values.role,
        email: values.create_email,

        location: values.create_location,
        mobile_number: values.create_phone,
        imageUrl: createUserImgUrl,
      });
    }
    let uid = localStorage.getItem("organisationId");
    dispatch(createProfile({ userData, uid })).then((res) => {
      if (res.payload.status === "success") {
        message.success("Admin Profile Updated");
        getAdminList();
        formCreate.resetFields();
        setCreateImage(dummy_user);
        setCreateUserImgUrl(null);
        setSelected("Admin List");
      } else {
        message.error(res.payload.message.payload);
      }
    });
  };

  const getProfile = () => {
    dispatch(getOrganisationData()).then((res) => {
      if (res.payload.status === "success") {
        let resData = res.payload.message.payload;
        setUserImage(res.payload.message.payload.imageURL);
        form.setFieldsValue({
          firstname: resData.firstName,
          lastname: resData.lastName,
          email: resData.email,
          organizational_name: resData.organisationName,
          phone: resData.mobile,
          location: resData.location,
          userId: resData.pcUserId,
        });
      }
    });
  };

  const getAdminList = async () => {
    let res = await dispatch(getAdminDataList());
    if (res?.payload?.response_message === "Success") {
      setList(res?.payload?.payload?.data);
    }

  };

  useEffect(() => {
    getProfile();
    getAdminList();
  }, []);

  const handleChange = async (info) => {
    const file = info.file?.originFileObj;
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("category", "PROFILE_PICTURE");

    try {
      const res = await dispatch(uploadFile(formData)).unwrap();
      if (res?.status === "success") {
        setUpdateImgUrl(res?.message?.payload);
        setUserImage(res?.message?.payload);
        setImage(res?.message?.payload);
      } else {
        message.error(res?.message?.payload);
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    }
  };
  const handleChangeCreate = async (info) => {
    const file = info.file?.originFileObj;
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("category", "PROFILE_PICTURE");

    try {
      const res = await dispatch(uploadFile(formData)).unwrap();
      if (res?.status === "success") {
        setCreateUserImgUrl(res?.message?.payload);
        setCreateImage(res?.message?.payload);
      } else {
        message.error("Something went wrong while uploading image");
      }
    } catch (err) {
      message.error("Something went wrong!");
      console.error(err);
    }
  };

  const isMobile = useIsMobile();

  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          {/* Header */}
          {isMobile ? (
            <>
              <div className="flex items-center justify-between gap-2 pb-3">
                <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">Profile</h1>
              </div>
            </>
          ) : (
            <>
              <div className="w-full mx-auto pl-[10px]">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">Profile</h1>
                </div>
              </div>
            </>
          )}

          {/* Tab Navigation */}
          <div className="pt-3">
            <div className="inline-flex flex-wrap items-center gap-1 p-1 bg-white rounded-xl border-[1px] border-solid border-[#E2E8F0] shadow-sm">
              <Button
                className={`px-[14px] h-[34px] rounded-lg border-0 text-[13px] font-semibold font-poppins transition-all ${selected === "Update Profile"
                    ? "!bg-[#0F172A] !text-white shadow-md"
                    : "!bg-[#F8FAFC] !text-[#334155] hover:!bg-gray-100"
                  }`}
                onClick={() => setSelected("Update Profile")}
              >
                Update Profile
              </Button>
              <Button
                className={`px-[14px] h-[34px] rounded-lg border-0 text-[13px] font-semibold font-poppins transition-all ${selected === "Admin List"
                    ? "!bg-[#0F172A] !text-white shadow-md"
                    : "!bg-[#F8FAFC] !text-[#334155] hover:!bg-gray-100"
                  }`}
                onClick={() => {
                  setSelected("Admin List");
                  getAdminList();
                }}
              >
                Admin List
              </Button>
              <Button
                className={`px-[14px] h-[34px] rounded-lg border-0 text-[13px] font-semibold font-poppins transition-all ${selected === "Add Admin"
                    ? "!bg-[#0F172A] !text-white shadow-md"
                    : "!bg-[#F8FAFC] !text-[#334155] hover:!bg-gray-100"
                  }`}
                onClick={() => setSelected("Add Admin")}
              >
                Add Admin
              </Button>
            </div>
          </div>

          <div className="border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9] mt-4 mb-4" />

          {/* Content Area */}
          <div className="pb-6">
            {selected === "Update Profile" ? (
              <div className="max-w-4xl">
                <div className="bg-white rounded-2xl p-[20px] md:p-[24px] border-[1px] border-solid border-[#E2E8F0] shadow-sm">
                  <h2 className="text-base font-semibold text-[#171717] font-poppins mb-6">Update Your Profile</h2>

                  <Form
                    form={form}
                    name="update-profile-form"
                    layout="vertical"
                    onFinish={onFinish}
                    className="space-y-4"
                  >
                    {/* Profile Image Section */}
                    <div className="flex flex-col items-center mb-8">
                      <div className="relative mb-4">
                        <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-lg">
                          <Image
                            src={userImage || dummy_user}
                            className="w-full h-full object-cover"
                            alt="Profile"
                          />
                        </div>
                        <Upload
                          accept=".jpg,.jpeg,.png"
                          showUploadList={false}
                          multiple={false}
                          beforeUpload={() => true}
                          customRequest={({ file, onSuccess }) => {
                            setUpdateFile(file.name);
                            handleChange({ file: { originFileObj: file } });
                            setTimeout(() => onSuccess("ok"), 0);
                          }}
                        >
                          <Button
                            className="btn-gradient absolute -bottom-1 -right-1 w-8 h-8 rounded-full border-2 border-white shadow-md flex items-center justify-center p-0"
                            icon={
                              <Image
                                src={edit_profile_icon}
                                className="w-4 h-4"
                                alt="Edit"
                              />
                            }
                          />
                        </Upload>
                      </div>
                      {updateFile && (
                        <p className="text-sm text-[#64748B] font-poppins mt-2">Selected: {updateFile}</p>
                      )}
                    </div>

                    <Form.Item name="userId" hidden>
                      <Input type="hidden" />
                    </Form.Item>

                    {/* Name Fields */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">First Name</span>}
                        name="firstname"
                        rules={[{ required: true, message: "First Name is required" }]}
                      >
                        <Input
                          placeholder="Enter First Name"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Last Name</span>}
                        name="lastname"
                        rules={[{ required: true, message: "Last Name is required" }]}
                      >
                        <Input
                          placeholder="Enter Last Name"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                    </div>

                    {/* Email and Organization */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Email Address</span>}
                        name="email"
                        rules={[
                          { required: true, message: "Email is required" },
                          { type: "email", message: "Please enter a valid email" }
                        ]}
                      >
                        <Input
                          placeholder="Enter Email Address"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Organization Name</span>}
                        name="organizational_name"
                        rules={[{ required: true, message: "Organization name is required" }]}
                      >
                        <Input
                          placeholder="Enter Organization Name"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                    </div>

                    {/* Phone and Location */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Phone Number</span>}
                        name="phone"
                        rules={[{ required: true, message: "Phone number is required" }]}
                      >
                        <Input
                          placeholder="Enter Phone Number"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Location</span>}
                        name="location"
                        rules={[{ required: true, message: "Location is required" }]}
                      >
                        <Input
                          placeholder="Enter Location"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                    </div>

                    {/* Submit Button */}
                    <div className="flex justify-start pt-4">
                      <Button
                        htmlType="submit"
                        className="btn-gradient border-0 h-11 px-8 rounded-xl text-sm font-semibold font-poppins shadow-sm hover:opacity-95"
                      >
                        Update Profile
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            ) : selected === "Add Admin" ? (
              <div className="max-w-4xl">
                <div className="bg-white rounded-2xl p-[20px] md:p-[24px] border-[1px] border-solid border-[#E2E8F0] shadow-sm">
                  <h2 className="text-base font-semibold text-[#171717] font-poppins mb-6">Add New Administrator</h2>

                  <Form
                    form={formCreate}
                    name="create-admin-form"
                    layout="vertical"
                    onFinish={onCreate}
                    className="space-y-4"
                  >
                    {/* Profile Image Section */}
                    <div className="flex flex-col items-center mb-8">
                      <div className="relative mb-4">
                        <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-lg">
                          <Image
                            src={createImage || dummy_user}
                            className="w-full h-full object-cover"
                            alt="Admin Profile"
                          />
                        </div>
                        <Upload
                          accept=".jpg,.jpeg,.png"
                          showUploadList={false}
                          multiple={false}
                          beforeUpload={() => true}
                          customRequest={({ file, onSuccess }) => {
                            setCreateFile(file.name);
                            handleChangeCreate({ file: { originFileObj: file } });
                            setTimeout(() => onSuccess("ok"), 0);
                          }}
                        >
                          <Button
                            className="btn-gradient absolute -bottom-1 -right-1 w-8 h-8 rounded-full border-2 border-white shadow-md flex items-center justify-center p-0"
                            icon={
                              <Image
                                src={edit_profile_icon}
                                className="w-4 h-4"
                                alt="Add Photo"
                              />
                            }
                          />
                        </Upload>
                      </div>
                      {createFile && (
                        <p className="text-sm text-[#64748B] font-poppins mt-2">Selected: {createFile}</p>
                      )}
                    </div>

                    {/* Title and Name Fields */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Title</span>}
                        name="title"
                        rules={[{ required: true, message: "Title is required" }]}
                      >
                        <Select
                          placeholder="Select Title"
                          className="h-12"
                          options={[
                            { label: "Mr.", value: "Mr" },
                            { label: "Mrs.", value: "Mrs" },
                            { label: "Ms.", value: "Ms" },
                          ]}
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">First Name</span>}
                        name="create_firstname"
                        rules={[{ required: true, message: "First name is required" }]}
                      >
                        <Input
                          placeholder="Enter First Name"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Last Name</span>}
                        name="create_lastname"
                        rules={[{ required: true, message: "Last name is required" }]}
                      >
                        <Input
                          placeholder="Enter Last Name"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                    </div>

                    {/* Role and Email */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Role</span>}
                        name="role"
                        rules={[{ required: true, message: "Role is required" }]}
                      >
                        <Select
                          placeholder="Select Role"
                          className="h-12"
                          options={[
                            { label: "Admin", value: "ADMIN" },
                            { label: "Event Admin", value: "ENTERPRISE_ADMIN" },
                          ]}
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Email Address</span>}
                        name="create_email"
                        rules={[
                          { required: true, message: "Email is required" },
                          { type: "email", message: "Please enter a valid email" }
                        ]}
                      >
                        <Input
                          placeholder="Enter Email Address"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                    </div>

                    {/* Phone and Location */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Phone Number</span>}
                        name="create_phone"
                        rules={[{ required: true, message: "Phone number is required" }]}
                      >
                        <Input
                          placeholder="Enter Phone Number"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                      <Form.Item
                        label={<span className="text-sm font-medium text-[#334155] font-poppins">Location</span>}
                        name="create_location"
                        rules={[{ required: true, message: "Location is required" }]}
                      >
                        <Input
                          placeholder="Enter Location"
                          className="h-11 rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white shadow-sm text-sm text-[#171717] placeholder:text-[#94A3B8] hover:border-[#CBD5E1] focus:border-[#2563EB] focus:ring-2 focus:ring-[#B3D7FF]"
                        />
                      </Form.Item>
                    </div>

                    {/* Submit Button */}
                    <div className="flex justify-start pt-4">
                      <Button
                        htmlType="submit"
                        className="btn-gradient border-0 h-11 px-8 rounded-xl text-sm font-semibold font-poppins shadow-sm hover:opacity-95"
                      >
                        Create Administrator
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            ) : (
              <div className="max-w-6xl">
                <div className="bg-white rounded-2xl p-[20px] md:p-[24px] border-[1px] border-solid border-[#E2E8F0] shadow-sm">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-base font-semibold text-[#171717] font-poppins mb-0">Administrator List</h2>
                    <div className="text-sm text-[#64748B] font-poppins">
                      Total Admins: <span className="font-semibold text-[#2563EB]">{list.length}</span>
                    </div>
                  </div>

                  {list.length > 0 ? (
                    <div className="overflow-hidden rounded-xl border-[1px] border-solid border-[#E2E8F0] bg-white">
                      <Table
                        col={col}
                        placeholder={"Search administrators..."}
                        data={list}
                        className="admin-list-table"
                      />
                    </div>
                  ) : (
                    <div className="flex flex-col items-center justify-center py-12 text-center">
                      <div className="w-24 h-24 bg-[#EFF6FF] rounded-full flex items-center justify-center mb-4">
                        <svg className="w-10 h-10 text-[#2563EB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                      </div>
                      <h3 className="text-base font-semibold text-[#171717] font-poppins mb-2">No Administrators Found</h3>
                      <p className="text-[#64748B] text-sm font-poppins mb-4">There are no administrators in the system yet.</p>
                      <Button
                        onClick={() => setSelected("Add Admin")}
                        className="btn-gradient border-0 h-10 px-6 rounded-xl text-[13px] font-semibold font-poppins hover:opacity-95"
                      >
                        Add First Administrator
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
